import { Link } from 'react-router-dom';
import { Brand } from '@/components/layout/Brand';
import { openAdsConsent } from '@/components/privacy/AdsConsent';

export function SiteFooter() {
  return (
    <footer className="mt-20 border-t bg-muted/35">
      <div className="mx-auto grid max-w-7xl gap-10 px-4 py-12 sm:px-6 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <Brand />
          <p className="mt-4 max-w-md text-sm leading-6 text-muted-foreground">
            Preparación privada e independiente para la prueba de conductor VTC de la Comunidad de Madrid.
          </p>
        </div>
        <div>
          <p className="text-sm font-semibold">Preparación</p>
          <div className="mt-3 grid text-sm text-muted-foreground [&_a]:flex [&_a]:min-h-11 [&_a]:items-center">
            <Link to="/simulacro">Simulacro completo</Link>
            <Link to="/estudio">Estudio por módulos</Link>
            <a href="/examen-vtc-madrid">Guía del examen</a>
            {/* Ancla y no <Link>: es una página estática sin ruta en React, y
                navegar por el router la convertiría en un 404. */}
            <a href="/curso-vtc-madrid">Curso de preparación</a>
            <Link to="/precios">Planes y precios</Link>
          </div>
        </div>
        <div>
          <p className="text-sm font-semibold">Perfiles y legal</p>
          <div className="mt-3 grid text-sm text-muted-foreground [&_a]:flex [&_a]:min-h-11 [&_a]:items-center">
            <Link to="/conductores">Conductores</Link>
            <Link to="/autonomos">Autónomos</Link>
            <Link to="/flotas">Flotas</Link>
            <Link to="/academias">Academias</Link>
            <a href="/privacidad">Privacidad</a>
            <button className="flex min-h-11 items-center text-left" type="button" onClick={openAdsConsent}>
              Gestionar medición
            </button>
            <a href="/condiciones">Condiciones</a>
            <a href="/aviso-legal">Aviso legal</a>
          </div>
        </div>
      </div>
      <div className="border-t px-4 py-5 text-center text-xs text-muted-foreground">
        © {new Date().getFullYear()} Permiso VTC Madrid · No es una web oficial de la Comunidad de Madrid.
      </div>
    </footer>
  );
}
